import { Injectable } from '@angular/core';

/**
 * Overrides the organization sent in the `Company` request header, which otherwise is the one picked
 * in the header dropdown. Used while a System Admin edits an organization's admin from that
 * organization's detail page, so the user calls go to that organization. Clear it when done.
 */
@Injectable({ providedIn: 'root' })
export class CompanyHeaderOverrideService {
  companyId: string | null = null;
}
